import { ApplicationConfig, provideBrowserGlobalErrorListeners,importProvidersFrom  } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { navigationTransition } from './core/navigation/navigation-transition';
import { authInterceptor } from './core/auth/auth.interceptor';
import { withInterceptors } from '@angular/common/http';
import { LucideAngularModule } from 'lucide-angular';
import { ChevronRight } from 'lucide-angular';


import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withViewTransitions(navigationTransition)),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(LucideAngularModule.pick({ ChevronRight })),
  ]
};
